import type { HTMLAttributes } from 'react';
import { cn } from './cn';

/* Kbd — клавиша в подсказках и меню: «⌘K», «a», «Esc». */
export function Kbd({ className, ...rest }: HTMLAttributes<HTMLElement>) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-xs border border-line bg-muted px-1 font-mono text-2xs text-fg-muted',
        className,
      )}
      {...rest}
    />
  );
}
